// Run this example by adding <%= javascript_pack_tag 'news' %> to your desired file.

import React from 'react'
import ReactDOM from 'react-dom'
import NewsAll from '../news/all'

const rootElement = document.getElementById('news-all')
const type = rootElement.dataset.type

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<NewsAll />, rootElement)
})